import { handleResponse, Headers } from '../_helpers';

export const AuthService = {
  login,
};

function login(userID) {
  const request = {
    method: 'POST',
    headers: Headers.set({ auth: false }),
    body: JSON.stringify({ userID }),
  };

  return fetch(`${process.env.API_URL}/api/v1/admin/auth`, request)
    .then(handleResponse)
    .then((user) => {
      // console.log('Service: User is', user);
      return user;
    });
}
